var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "projectAddVersionModal",
        size: "md",
        "hide-header-close": "",
        "no-stacking": "",
        title: _vm.$t("message.add_version"),
      },
      on: {
        hide: function ($event) {
          return _vm.resetValues()
        },
      },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function ({ cancel }) {
            return [
              _c(
                "b-button",
                {
                  attrs: { size: "md", variant: "secondary" },
                  on: {
                    click: function ($event) {
                      return cancel()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("message.cancel")))]
              ),
              _c(
                "b-button",
                {
                  attrs: {
                    size: "md",
                    variant: "primary",
                    disabled: _vm.isSubmitButtonDisabled,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.createVersion()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("message.create")))]
              ),
            ]
          },
        },
      ]),
    },
    [
      _c(
        "b-row",
        { attrs: { "align-v": "stretch" } },
        [
          _c(
            "b-col",
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    id: "fieldset-1",
                    label: this.$t("message.version"),
                    "label-for": "input-1",
                    "label-class": "required",
                  },
                },
                [
                  _c("b-form-input", {
                    staticClass: "required",
                    attrs: { id: "input-1", trim: "", required: "" },
                    model: {
                      value: _vm.version,
                      callback: function ($$v) {
                        _vm.version = $$v
                      },
                      expression: "version",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { cols: "auto" } },
            [
              _c("b-input-group-form-switch", {
                attrs: {
                  id: "project-details-islatest",
                  label: _vm.$t("message.project_is_latest"),
                  "show-placeholder-label": true,
                },
                model: {
                  value: _vm.makeCloneLatest,
                  callback: function ($$v) {
                    _vm.makeCloneLatest = $$v
                  },
                  expression: "makeCloneLatest",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-form-checkbox",
        {
          attrs: {
            id: "checkbox-1",
            name: "checkbox-1",
            switch: "",
            value: "true",
            "unchecked-value": "false",
          },
          model: {
            value: _vm.includeTags,
            callback: function ($$v) {
              _vm.includeTags = $$v
            },
            expression: "includeTags",
          },
        },
        [_vm._v("\n    " + _vm._s(_vm.$t("message.include_tags")))]
      ),
      _c(
        "b-form-checkbox",
        {
          attrs: {
            id: "checkbox-2",
            name: "checkbox-2",
            switch: "",
            value: "true",
            "unchecked-value": "false",
          },
          model: {
            value: _vm.includeProperties,
            callback: function ($$v) {
              _vm.includeProperties = $$v
            },
            expression: "includeProperties",
          },
        },
        [_vm._v("\n    " + _vm._s(_vm.$t("message.include_properties")))]
      ),
      _c(
        "b-form-checkbox",
        {
          attrs: {
            id: "checkbox-3",
            name: "checkbox-3",
            switch: "",
            value: "true",
            "unchecked-value": "false",
          },
          model: {
            value: _vm.includeComponents,
            callback: function ($$v) {
              _vm.includeComponents = $$v
            },
            expression: "includeComponents",
          },
        },
        [_vm._v("\n    " + _vm._s(_vm.$t("message.include_components")))]
      ),
      _c(
        "b-form-checkbox",
        {
          attrs: {
            id: "checkbox-4",
            name: "checkbox-4",
            switch: "",
            value: "true",
            "unchecked-value": "false",
          },
          model: {
            value: _vm.includeServices,
            callback: function ($$v) {
              _vm.includeServices = $$v
            },
            expression: "includeServices",
          },
        },
        [_vm._v("\n    " + _vm._s(_vm.$t("message.include_services")))]
      ),
      _c(
        "b-form-checkbox",
        {
          attrs: {
            id: "checkbox-5",
            name: "checkbox-5",
            switch: "",
            value: "true",
            "unchecked-value": "false",
          },
          model: {
            value: _vm.includeAuditHistory,
            callback: function ($$v) {
              _vm.includeAuditHistory = $$v
            },
            expression: "includeAuditHistory",
          },
        },
        [_vm._v("\n    " + _vm._s(_vm.$t("message.include_audit_history")))]
      ),
      _c(
        "b-form-checkbox",
        {
          attrs: {
            id: "checkbox-6",
            name: "checkbox-6",
            switch: "",
            value: "true",
            "unchecked-value": "false",
          },
          model: {
            value: _vm.includeACL,
            callback: function ($$v) {
              _vm.includeACL = $$v
            },
            expression: "includeACL",
          },
        },
        [_vm._v("\n    " + _vm._s(_vm.$t("message.include_acl")))]
      ),
      _c(
        "b-form-checkbox",
        {
          attrs: {
            id: "checkbox-7",
            name: "checkbox-7",
            switch: "",
            value: "true",
            "unchecked-value": "false",
          },
          model: {
            value: _vm.includePolicyViolations,
            callback: function ($$v) {
              _vm.includePolicyViolations = $$v
            },
            expression: "includePolicyViolations",
          },
        },
        [_vm._v("\n    " + _vm._s(_vm.$t("message.include_policy_violations")))]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }